import {
  GET_ACTIVE_JOB,
  GET_APPLIED_JOB,
  GET_COMPLETE_JOB,
  GET_JOB,
  GET_JOB_BY_ID,
  GET_MYOREDR_JOB,
} from "../constants";

export const job = (
  state = {
    getjoblist: [],
    getjobbyid: [],
    getjobappliedlist: [],
    getjobactivelist: [],
    getjobcompletelist: [],
    myorderjoblist: [],
  },
  action,
) => {
  switch (action.type) {
    case GET_JOB:
      return { ...state, getjoblist: action.getjoblist };
    case GET_JOB_BY_ID:
      return { ...state, getjobbyid: action.getjobbyid };
    case GET_APPLIED_JOB:
      return { ...state, getjobappliedlist: action.getjobappliedlist };
    case GET_ACTIVE_JOB:
      return { ...state, getjobactivelist: action.getjobactivelist };
    case GET_COMPLETE_JOB:
      return { ...state, getjobcompletelist: action.getjobcompletelist };
    case GET_MYOREDR_JOB:
      return { ...state, myorderjoblist: action.myorderjoblist };
    default:
      return state;
  }
};
